export default "__VITE_ASSET__1JOPe0zz__"